export default function confrim(message, callback, callbackCancel = () => this.popupHide(), importance = "low") {
    this.confirm(message, callback, callbackCancel, importance);
}
